// extracted by mini-css-extract-plugin
module.exports = {"slide":"slide-module--slide--3zPAW"};